<template>
  <el-dialog
    title="领取列表"
    :visible.sync="dialogVisible"
    width="1100px"
    :close-on-click-modal="false"
    top="5vh"
  >
    <!-- 搜索区域 -->
    <div class="search-area">
      <el-form :inline="true" :model="searchForm">
        <el-form-item label="优惠券名称">
          <el-input
            v-model="searchForm.couponName"
            placeholder="请输入优惠券名称"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item label="客户名称">
          <el-input
            v-model="searchForm.shopName"
            placeholder="请输入客户名称"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" size="small"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      height="600"
    >
      <el-table-column prop="couponName" label="优惠券名称" />
      <el-table-column label="有效时间" width="220">
        <template slot-scope="scope">
          {{ scope.row.effectiveTime }} 至 {{ scope.row.expirationTime }}
        </template>
      </el-table-column>
      <el-table-column prop="shopName" label="客户名称" width="180" />
      <el-table-column prop="sendNumber" label="发券数量" width="100" />
      <el-table-column prop="usedNumber" label="已用" width="100" />
      <el-table-column prop="sendShopName" label="发券人" width="120" />
      <el-table-column prop="collectionTime" label="发券时间" width="180" />
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.current"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      />
    </div>
  </el-dialog>
</template>

<script>
import { getCouponListWithClaimed } from "@/api/coupon";
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      searchForm: {
        couponName: "",
        shopName: "",
        activityId: "",
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 13,
      },
    };
  },
  methods: {
    publicOpen(activity) {
      this.pagination.current = 1;
      this.searchForm.activityId = activity.id;
      this.dialogVisible = true;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      const params = { ...this.searchForm, ...this.pagination };
      delete params.total;
      getCouponListWithClaimed(params)
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.records;
          this.pagination.total = res.data.total;
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      this.pagination.current = 1;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.pagination.size = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.search-area {
  margin-bottom: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
